import {AfterViewInit, Component, OnInit} from '@angular/core';
import {Article} from './common/types/cec.types';
import {LoggedUser} from './common/types/loggedUser';
import {Competitor, Role} from './common/types/competitor';
import {LoggedCompetitor} from './common/types/loggedCompetitor';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {LocalStorageService} from './api/services/localStorage';
import {HttpHandlingService} from './api/services/http-handling.service';
import {Season} from './common/types/season';
import { SERVER_API_URL} from './common/types/app.constants';
import { NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit{
  title = 'cec-website';

  constructor(private localStorage: LocalStorageService, private http: HttpClient, private httpHandlingService: HttpHandlingService, private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        console.log('NavigationStart:', event.url);
      }
    });
  }

  ngOnInit(): void {
    
    // this.getActiveSeason();
  }

  // getActiveSeason(): void {
  //   // const activeSeasonURL = 'http://localhost:8080/api/seasons/active';
  //   const activeSeasonURL = SERVER_API_URL + '/api/seasons/active';
  //   this.http.get<Season>(activeSeasonURL, {headers: this.httpHandlingService.authorizationHeaders()})
  //     .subscribe((season: Season) => {
  //       this.localStorage.set('activeSeason', season);
  //       },
  //     );
  // }

  ngAfterViewInit(): void {
    // this.getActiveSeason();
  }
}
